module.exports = __webpack_public_path__ + "static/media/palmistry-assessment.59f325d1.png";